export function getSearchRelevance(query, entity) {
    let result = false;
    for (const translation of Object.values(entity?.name ?? {})) {
        if (query.test(translation) && (!result || translation.length < result)) {
            result = translation.length;
        }
    }
    return result;
}
//# sourceMappingURL=get-search-relevance.js.map